import { CustomerTypeEnum } from '../../enums/CustomerTypeEnum';
import { PersonDto } from './PersonDto';
import { OrganizationDto } from './OrganizationDto';
import { AddressDto } from '../AddressDto';

export class CustomerDto {
  customerType: CustomerTypeEnum;
  person: PersonDto;
  organization: OrganizationDto;
}
